import type { BidiInstance } from 'bidi-js';
import type { ParsedSegment, TextSegmentParser } from './types';
import type { TextEffectsSharedMapperProps } from '../../TextEffectsShared.types';
import { isVisibleSegment } from './isVisibleSegment';

export const parseWord: TextSegmentParser = (
  str: string,
  _textDirection: TextEffectsSharedMapperProps['textDirection'],
  segmenter: Intl.Segmenter,
  normalize: (segments: Array<ParsedSegment>) => Array<Array<ParsedSegment>>,
  _bidi: BidiInstance,
) => {
  const segments = Array.from(segmenter.segment(str), segment => ({
    data: segment.segment,
    isVisible: isVisibleSegment(segment.segment),
  }));

  return {
    segmentsBrokenByLines: normalize(segments),
  };
};
